import React from "react";
import PropTypes from "prop-types";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";

export default function TimelineArrow({ direction, onClick }) {
  function Arrow() {
    return direction === "left" ? (
      <ChevronLeft data-testid="TimelineArrow-ChevronLeft" />
    ) : (
      <ChevronRight data-testid="TimelineArrow-ChevronRight" />
    );
  }

  return (
    <div
      onClick={onClick}
      className={`timeline-arrow timeline-arrow-${direction} ${!onClick ? "disabled" : ""}`}
      data-testid="TimelineArrow"
    >
      <Arrow />
    </div>
  );
}

TimelineArrow.propTypes = {
  direction: PropTypes.string,
  onClick: PropTypes.func,
};

TimelineArrow.defaultProps = {
  direction: "left",
  onClick: null,
};
